import { Order } from '../../../interfaces/Order/Order'

// Tipos específicos para OrderPage
export interface OrderFormData {
  id: number
  referenceId: number
  courierId: number
  courierServiceId: number
  orderStateId: number
  courierDeliveryDate: Date
  quantity: number
  workOrderStateId: number
  workOrderId: number
  warehouseId: number
  orderOriginId: number
  typeOrderId: number
}

export interface CreateWorkOrderData {
  typeWorkOrderId: number
  workOrderDetails: { orderId: number }[]
  warehouseId: number
}

export interface OrderPageState {
  selectedFilters: any[]
  selectedElements: number[]
  orderBy: {
    field: keyof Order
    direction: 'asc' | 'desc'
  }
}

// Constantes para estados de pedidos
export const ORDER_STATES = {
  CREATED: 1,
  CANCELLATIONREQUEST: 2,
  CANCELLED: 3,
  AWAITINGSTOCK: 4,
  INPREPARATION: 5,
  FULFILLMENTCOMPLETED: 6
} as const

export const ORDER_STATE_LABELS = {
  [ORDER_STATES.CREATED]: 'Creado',
  [ORDER_STATES.CANCELLATIONREQUEST]: 'Solicitud De Cancelación',
  [ORDER_STATES.CANCELLED]: 'Cancelado',
  [ORDER_STATES.AWAITINGSTOCK]: 'En Espera de stock',
  [ORDER_STATES.INPREPARATION]: 'En Preparación',
  [ORDER_STATES.FULFILLMENTCOMPLETED]: 'Gestión Completada'
} as const

export const ORDER_STATE_COLORS = {
  [ORDER_STATES.CREATED]: {
    background: '#757575',
    color: '#ffffffff'
  },
  [ORDER_STATES.CANCELLATIONREQUEST]: {
    background: '#f57c00',
    color: '#ffffffff'
  },
  [ORDER_STATES.INPREPARATION]: {
    background: '#004bb1',
    color: '#ffffffff'
  },
  [ORDER_STATES.CANCELLED]: {
    background: '#d32f2f',
    color: '#ffffffff'
  },
  [ORDER_STATES.AWAITINGSTOCK]: {
    background: '#fbc02d',
    color: '#ffffffff'
  },
  [ORDER_STATES.FULFILLMENTCOMPLETED]: {
    background: '#388e3c',
    color: '#ffffffff'
  }
} as const